export default __webpack_public_path__ + "static/media/signup-logo.572849ff.svg";